import { rpc } from '@server/infrastructure/rpc'
import { queryOptions } from '@tanstack/react-query'

export const couponEntityQueries = {
  all: ['coupons'],

  // queryKeys
  availableCouponsQueryKey: (requestDto: RequestQueryOptions) => [
    ...couponEntityQueries.all,
    'availableCoupons',
    requestDto,
  ],

  couponHistoryQueryKey: (requestDto: RequestQueryOptions) => [...couponEntityQueries.all, 'couponHistory', requestDto],

  // queryOptions
  availableCoupons: (requestDto: RequestQueryOptions) =>
    queryOptions({
      queryKey: couponEntityQueries.availableCouponsQueryKey(requestDto),
      queryFn: async () => {
        const response = await rpc.api.v1.coupons.available.$get(
          {},
          { headers: { Authorization: `Bearer ${requestDto.bearerToken}` } },
        )

        if (!response.ok) {
          throw new Error(`Failed to fetch available coupons: ${response.status}`)
        }

        return response.json()
      },
    }),
  couponHistory: (requestDto: RequestQueryOptions) =>
    queryOptions({
      queryKey: couponEntityQueries.couponHistoryQueryKey(requestDto),
      queryFn: async () => {
        const response = await rpc.api.v1.coupons.history.$get(
          {},
          { headers: { Authorization: `Bearer ${requestDto.bearerToken}` } },
        )

        if (!response.ok) {
          throw new Error(`Failed to fetch coupon history: ${response.status}`)
        }

        return response.json()
      },
    }),
} as const
